import { PolycomExpansionModel, YealinkExpansionModel } from '../enums';

export const ALL_EXPANSION_MODELS = { ...YealinkExpansionModel, ...PolycomExpansionModel };
